import request from 'sb-request'
import { reducers } from 'redux/core'


const fetch = () => {
  reducers.view.myOrdersPage.setFetchingStatus(true)

  request.get('rest/profile/orders')
    // TODO ask backend to remove `orders` key from response
    .then(
      ({ orders: result }) => {
        reducers.view.myOrdersPage.setItems(result)
      },
      () => {
        reducers.view.myOrdersPage.setFetchingStatus(false)
        return Promise.reject()
      }
    )
}

const reset = reducers.view.myOrdersPage.reset // eslint-disable-line

export default {
  reset,
  fetch,
}
